import { Configuration } from '@azure/msal-browser'

import Config from '../config'

export const msalConfig: Configuration = {
  auth: {
    clientId: Config.auth.clientId,
    authority: Config.auth.authority,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
    secureCookies: true,
  },
}
